<template>
  <div class="row justify-content-center">
    <div class="col-11 col-md-8 my-2">
      <h4 class="text-center">{{ $t('po_lc_he_loc-create') }}</h4>
      <div v-if="createError" class="alert alert-danger" role="alert">
        {{ $t('po_lc_tx_error_create') }}
      </div>
      <form id="Login" @submit.prevent="create">

        <div class="card mb-4">
          <div class="card-body">
            <h5 class="card-title">{{ $t('po_re_he_location') }}</h5>
            <h6 class="card-subtitle mb-2 text-muted">{{ $t('po_re_sh_location') }}</h6>
            <location-form v-model=locationData></location-form>
          </div>
        </div>

        <div class="card mb-4">
          <div class="card-body">
            <h5 class="card-title">{{ $t('po_re_he_location_details') }}</h5>
            <h6 class="card-subtitle mb-2 text-muted">{{ $t('po_re_sh_location_details') }}</h6>
            <location-details-form v-model=locationDetailsData></location-details-form>
          </div>
        </div>

        <div class="card mb-4">
          <div class="card-body">
            <h5 class="card-title">{{ $t('po_re_he_location_opening_horus') }}</h5>
            <h6 class="card-subtitle mb-2 text-muted">{{ $t('po_re_sh_location_opening_horus') }}</h6>
            <location-opening-hours-form v-model=locationOpeningHoursData></location-opening-hours-form>
          </div>
        </div>

        <div class="card mb-4">
          <div class="card-body">
            <h5 class="card-title">{{ $t('po_re_he_location_upload_logo') }}</h5>
            <h6 class="card-subtitle mb-2 text-muted">{{ $t('po_re_sh_location_upload_logo') }}</h6>

            <!-- File upload component -->
            <file-upload
              v-model="file"
              :required="false"
              accept="image/*"
              :maxSizeInMB="5"
            ></file-upload>

            <!-- Display selected file info -->
            <div v-if="file" class="mt-3 p-3 border rounded bg-light">
              <p class="mb-1"><strong>Name:</strong> {{ file.name }}</p>
              <p class="mb-1"><strong>Type:</strong> {{ file.type }}</p>
              <p class="mb-1"><strong>Size:</strong> {{ formatFileSize(file.size) }}</p>
            </div>
          </div>
        </div>

        <div class="d-grid mb-4">
          <button type="submit" class="col btn btn-primary mt-3">
            {{ $t('po_lc_bt_create') }}
          </button>
        </div>
      </form>

      <form @submit.prevent="handleFileUpload" id="FileUploadForm"></form>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import locationForm from '@/components/location/LocationForm.vue'
import locationDetailsForm from '@/components/location/LocationDetailsForm.vue'
import locationOpeningHoursForm from '@/components/location/LocationOpeningHoursForm.vue'
import FileUpload from '@/components/common/FileUpload.vue'

export default {
  components: {
    locationForm,
    locationDetailsForm,
    locationOpeningHoursForm,
    FileUpload
  },
  setup () {
    return {
      v$: useVuelidate({ $autoDirty: true })
    }
  },
  data: function () {
    return {
      createError: false,
      locationData: {
        locationType: 'restaurant',
        address: {
          country: 'at'
        }
      },
      locationDetailsData: {},
      locationOpeningHoursData: [],
      file: null,
      uploadStatus: null
    }
  },
  computed: {
    organisation: function () {
      return this.$store.state.organisation.organisation || {}
    },
    organisationUsers: function () {
      return this.$store.state.organisation.organisationUsers || []
    }
  },
  methods: {
    async create () {
      if (await this.v$.$validate()) {
        const submitData = { ...this.locationData, ...this.locationDetailsData }

        submitData.language = 'de'
        submitData.timezone = 'Europe/Vienna'
        submitData.currency = 'EUR'
        submitData.active = false
        submitData.visible = false
        submitData.texts = [
          {
            language: 'de',
            name: this.locationData.name,
            description: this.locationData.description
          }
        ]
        submitData.data = {
          googleMapsLink: this.locationDetailsData.googleMapsLink
        }

        try {
          const locationResponse = await this.axios.post('/vendor/restaurants/', submitData)

          if (this.locationOpeningHoursData) {
            await this.axios.put(`/vendor/restaurants/${locationResponse.data.data.id}/hours`, this.locationOpeningHoursData)
          }

          if (this.file) {
            const fileUploadResponse = await this.handleFileUpload(locationResponse.data.data.uuid)
            locationResponse.data.data.logo = fileUploadResponse.data.key
            await this.axios.put(`vendor/restaurants/${locationResponse.data.data.id}`, locationResponse.data.data)
          }

          await this.$auth.fetch()
          await this.$store.dispatch('updateOrganisation')
          this.$router.push({ name: 'locations' })
        } catch (e) {
          console.log(e)
          this.createError = true
        }
      }
    },

    async handleFileUpload (locationUuid) {
      // Create FormData object for multipart/form-data request
      const formData = new FormData()
      formData.append('file', this.file)

      // Send POST request to the specified endpoint
      try {
        const response = await this.axios.post(`/vendor/locations/${locationUuid}/files`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })

        // Reset form after successful upload
        this.file = null
        return response
      } catch (e) {
        // Handle upload error
        console.error('Upload error:', e)
        this.uploadStatus = {
          success: false
        }
      }
    },

    formatFileSize (bytes) {
      if (bytes === 0) return '0 Bytes'

      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    }
  }
}
</script>
